module.exports = __webpack_public_path__ + "assets/img/CP-3.f7e881d7.jpg";